import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import "./information.css";

const blogs = [
  {
    id: 1,
    image: './images/offices.webp',
    title:
      "Office Space in Gandhinagar: A Guide for Startups and Entrepreneurs",
    desc: "Office space in Gandhinagar offers numerous opportunities for startups and entrepreneurs. Here's a comprehensive guide to help you navigate the options available.",
  },
  {
    id: 2,
    image: './images/schools.webp',
    title:
      "School Admissions in Gandhinagar: A Parent's Guide to Finding the Perfect Fit",
    desc: "School admissions in Gandhinagar can be a daunting task for parents. This guide provides insights into the admission process, tips for selecting the right school.",
  },
  {
    id: 3,
    image: './images/house.webp',
    title: "Home Buying in Gandhinagar: Tips for First-Time Buyers",
    desc: "Buying your first home is an exciting milestone. Here are some essential tips to help you navigate the process smoothly. for first-time buyers in Gandhinagar.",
  },
];

const Information = () => {
  return (
    <div>
      <section className="blog-section">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 70 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            viewport={{ once: true }}
            className="text-center mb-5"
          >
            <span className="blog-subtitle">Latest Articles</span>

            <h2 className="blog-title">News & Blogs</h2>

            <p className="blog-heading-text">
              Explore expert insights, educational tips, and the latest updates.
            </p>
          </motion.div>

          <Row className="g-4">
            {blogs.map((blog, index) => (
              <Col lg={4} md={6} key={blog.id}>
                <motion.div
                  initial={{ opacity: 0, y: 70 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{
                    duration: 0.6,
                    delay: index * 0.15,
                  }}
                  viewport={{ once: true }}
                >
                  <Card className="blog-card">
                    <div className="blog-image">
                      <Card.Img src={blog.image} alt="" />
                    </div>

                    <Card.Body>
                      {/* <span className="blog-date">{blog.date}</span> */}

                      <h3 className="blog-card-title">{blog.title}</h3>

                      <p className="blog-desc">{blog.desc}</p>

                      <button className="read-btn">
                        View More
                        <FaArrowRight />
                      </button>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Information;
